import React, { useEffect, useMemo, useState } from "react";
import ContentLayout from "app/layouts/ContentLayout";
import routePaths from "app/route/routePaths";
import Button from "app/components/UI/Button";
import { orderServices } from "app/services/api";
import { toast } from "react-toastify";
import PageLoading from "app/components/CommonPage/PageLoading";
import PageError from "app/components/CommonPage/PageError";
import PageNoData from "app/components/CommonPage/PageNoData";
import TestMaterialInfoTableForm from "app/components/Table/Order/TestMaterialInfoTableForm";
import OrderSumaryUpdateTable from "app/components/Table/Order/OrderSumaryUpdateTable";
import { Tab, Tabs } from "@mui/material";
import PageLoadingBackdrop from "../../../components/CommonPage/PageLoadingBackdrop";
import messages from "../../../services/api/messages";
import CustomerTableInfo from "../../../components/Table/Customer/CustomerTableInfo";
import AddressCell from "../CustomerCustomTableCell/AddressCell";
import DepartmentCell from "../CustomerCustomTableCell/DepartmentCell";
import SelectTestScheduleAndCaseId from "../../../components/UI/Form/Select/SelectTestScheduleAndCaseId";
import { validateTestMaterialInfosConfig } from "../validate";
import { caseStatus, requestFormStatus } from "../../../constants";
import PhoneCell from "../CustomerCustomTableCell/PhoneCell";
import { getMessageFromCaseStatus } from "app/utils/getMessageFromCaseStatus";

const customerConfig = [
  {
    title: "企業・団体名",
    shouldEdit: true,
    showInput: false,
    dataKey: "customerName",
  },
  {
    title: "所在地",
    shouldEdit: true,
    showInput: false,
    dataKey: ["customerPostalCode", "customerAddress"],
    CustomTableCell: AddressCell,
  },
  {
    title: "TEL",
    dataKey: "phone1",
    shouldEdit: true,
    showInput: false,
    CustomTableCell: PhoneCell,
  },
  {
    title: "担当者",
    shouldEdit: true,
    showInput: false,
    dataKey: ["department", "picNameKanji"],
    CustomTableCell: DepartmentCell,
  },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CreateTestContentInfoForm({
  testContentInfoItem,
  setTestContentInfoItem,
  requestFormInfo,
  setRequestFormInfo,
  customerTable,
  onChangeCustomer,
  handleClickEditCus,
}) {
  const [showTab, setShowTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setShowTab(newValue);
  };

  const handleChangeTestMaterial = (index, newValue) => {
    const newTestMaterialInfos = [...testContentInfoItem?.testMaterialInfos];
    newTestMaterialInfos[index] = newValue;
    setTestContentInfoItem({
      ...testContentInfoItem,
      testMaterialInfos: newTestMaterialInfos,
    });
  };

  return (
    <div className="w-full h-auto">
      <div className="w-full h-auto mb-10">
        <CustomerTableInfo
          id="lab"
          key="lab"
          tableConfig={[
            {
              title: "項目",
              width: "25%",
              textAlign: "left",
            },
            {
              title: "詳細",
              width: "75%",
              textAlign: "left",
            },
          ]}
          tableData={customerTable}
          onClickEdit={handleClickEditCus}
          handleChange={onChangeCustomer}
        />
      </div>

      <div className="w-full h-auto mb-10">
        <OrderSumaryUpdateTable
          testContentInfoItem={testContentInfoItem}
          isReadonly={false}
          requestFormInfo={requestFormInfo}
          setRequestFormInfo={setRequestFormInfo}
        />
      </div>

      <div className="w-full">
        <div className="w-full overflow-x-auto">
          <Tabs
            value={showTab}
            onChange={handleChangeTab}
            aria-label="basic tabs example"
            className="mb-3"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabScrollButton-root.Mui-disabled": {
                opacity: 0.3,
              },
            }}
          >
            {testContentInfoItem.testMaterialInfos.map((item, index) => (
              <Tab
                key={`tab-${index}`}
                label={`${index + 1}`}
                className="!min-w-[45px]"
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </div>

        {testContentInfoItem.testMaterialInfos.map((item, index) => (
          <CustomTabPanel key={index} value={showTab} index={index}>
            <TestMaterialInfoTableForm
              testMaterialNo={index + 1}
              testMaterialInfo={item}
              setTestMaterialInfo={(newValue) =>
                handleChangeTestMaterial(index, newValue)
              }
            />
          </CustomTabPanel>
        ))}
      </div>
    </div>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="w-full h-full">{children}</div>}
    </div>
  );
}

function UpdateOrderResult({
  initOrderInfo,
  caseId,
  handleSearch,
  orderStatus,
}) {
  const [requestFormInfo, setRequestFormInfo] = useState(initOrderInfo);
  const [showTab, setShowTab] = useState(0);
  const [isCreating, setIsCreating] = useState(false);
  const [comment, setComment] = useState("");

  const [customerTable, setCustomerTable] = useState(
    customerConfig.map((i) => {
      const detail = [];
      if (Array.isArray(i.dataKey)) {
        i.dataKey.forEach((d) => {
          detail[d] = initOrderInfo[d];
        });
      }
      return {
        ...i,
        detail: Array.isArray(i.dataKey) ? detail : initOrderInfo[i.dataKey],
      };
    })
  );

  const handleChangeTestContentInfo = (index, newValue) => {
    setRequestFormInfo((oldState) => {
      const newTestContentInfos = [...oldState.testContentInfos];
      newTestContentInfos[index] = newValue;
      return {
        ...oldState,
        testContentInfos: newTestContentInfos,
      };
    });
  };

  const handleChangeTab = (event, newValue) => {
    setShowTab(newValue);
  };

  const handleUpdateSubmit = () => {
    if (isCreating) return;

    customerTable.forEach((i) => {
      if (Array.isArray(i.dataKey)) {
        i.dataKey.forEach((key) => {
          requestFormInfo[key] = i.detail[key] ?? "";
        });
      } else {
        requestFormInfo[i.dataKey] = i.detail;
      }
    });

    let textErrors = [];

    validateTestMaterialInfosConfig.forEach((valid) => {
      if (!valid.value && !valid.required_if && !requestFormInfo[valid.name]) {
        textErrors.push(valid.text);
      }
      if (
        valid.value &&
        requestFormInfo[valid.name] &&
        requestFormInfo[valid.name] === valid.value
      ) {
        if (!textErrors.includes(valid.text)) {
          textErrors.push(valid.text);
        }
      }
      requestFormInfo.testContentInfos?.forEach((testContentInfo) => {
        testContentInfo.testMaterialInfos.forEach((testMaterialInfo) => {
          if (
            valid.value &&
            testMaterialInfo[valid.name] &&
            testMaterialInfo[valid.name] === valid.value
          ) {
            if (!textErrors.includes(valid.text)) {
              textErrors.push(valid.text);
            }
          }

          if (
            valid.required_if &&
            testMaterialInfo[valid.required_if] &&
            testMaterialInfo[valid.required_if] === valid.required_value
          ) {
            if (!testMaterialInfo[valid.name]) {
              if (!textErrors.includes(valid.text)) {
                textErrors.push(valid.text);
              }
            }
          }
        });
      });
    });

    if (textErrors.length > 0) {
      textErrors.forEach((text) => {
        toast.error(text + "を記入してください。");
      });

      return;
    }

    const data = {
      ...requestFormInfo,
      generatedPdf: undefined,
      id: undefined,
      caseId,
    };

    delete data.rejectComment;
    delete data.status;
    delete requestFormInfo.status;
    delete data.requestFormStatus;

    setIsCreating(true);
    orderServices
      .genFileRequestForm(data)
      .then((res) => {
        const generatedWord = res?.data?.generatedWord;
        const requestFormInfoData = {
          ...requestFormInfo,
          generatedPdf: generatedWord._id,
          comment: comment,
          caseId: caseId,
        };

        delete requestFormInfoData.rejectComment;
        delete requestFormInfoData.status;
        delete requestFormInfoData.requestFormStatus;

        orderServices
          .updateRequestForm(requestFormInfoData)
          .then((res) => {
            toast.success(messages.update(true));
            setIsCreating(false);
          })
          .catch((error) => {
            console.log("error: ", error);
            toast.error(messages.update(false));
            setIsCreating(false);
            setTimeout(() => {
              handleSearch();
            }, 1000);
          });
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error(messages.callApiFail);
        setIsCreating(false);
      });
  };

  const handleClickEditCus = (dataKey) => {
    const newCus = customerTable.map((c) => ({
      ...c,
      showInput: c.dataKey === dataKey ? !c.showInput : c.showInput,
    }));
    setCustomerTable(newCus);
  };

  const onChangeCustomer = (name, value) => {
    const newCus = customerTable.map((c) => {
      const detail = c.detail;

      if (Array.isArray(c.detail)) {
        c.detail[name] = value;
      }

      return {
        ...c,
        detail: Array.isArray(c.dataKey)
          ? detail
          : c.dataKey === name
          ? value
          : c.detail,
      };
    });

    setCustomerTable(newCus);
  };

  const handleSaveDraft = () => {
    if (isCreating) return;

    customerTable.forEach((i) => {
      if (Array.isArray(i.dataKey)) {
        i.dataKey.forEach((key) => {
          requestFormInfo[key] = i.detail[key] ?? "";
        });
      } else {
        requestFormInfo[i.dataKey] = i.detail;
      }
    });

    const data = { ...requestFormInfo };
    delete data.status;

    setIsCreating(true);
    orderServices
      .updateDraftRequestForm(data)
      .then((res) => {
        toast.success(messages.update(true));
        setIsCreating(false);
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error(messages.update(false));
        setIsCreating(false);
      });
  };

  return (
    <>
      <div className="w-full h-auto">
        <div className="w-full h-auto flex items-center justify-between mb-4">
          <h3 className="text-custom-size">試験内容</h3>

          <div className="flex items-center gap-4">
            {/*{requestFormInfo.status === "draft" && (*/}
            {/*  <Button type="secondary" onClick={handleSaveDraft}>*/}
            {/*    下書きを保存*/}
            {/*  </Button>*/}
            {/*)}*/}
            <Button type="primary" onClick={handleUpdateSubmit}>
              登録する
            </Button>
          </div>
        </div>

        <div className="w-full">
          {orderStatus === requestFormStatus.rejected && (
            <div className="border border-[#B3B3B3] mb-5">
              <div>
                <p className="bg-[#EBEBEB] p-2">再対応依頼コメント:</p>
                <p className="p-2">{requestFormInfo?.rejectComment || ""}</p>
              </div>
              <div>
                <p className="bg-[#EBEBEB] p-2">コメント:</p>
                <div className="p-2">
                  <textarea
                    onChange={(e) => setComment(e.target.value)}
                    className="w-full min-h-[100px] !outline-none rounded-[10px] border border-[#B3B3B3] px-3 py-3 text-start text-custom-size"
                    rows="3"
                  >
                    {comment}
                  </textarea>
                </div>
              </div>
            </div>
          )}

          <div className="w-full overflow-x-auto">
            <Tabs
              value={showTab}
              onChange={handleChangeTab}
              aria-label="basic tabs example"
              className="mb-3"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabScrollButton-root.Mui-disabled": {
                  opacity: 0.3,
                },
              }}
            >
              {requestFormInfo.testContentInfos.map(
                (testContentInfoItem, index) => {
                  return testContentInfoItem?.testMaterialInfos?.length > 0 ? (
                    <Tab
                      key={index}
                      label={
                        testContentInfoItem?.testItemName || `Tab ${index + 1}`
                      }
                      {...a11yProps(index)}
                    />
                  ) : null;
                }
              )}
            </Tabs>
          </div>

          {requestFormInfo.testContentInfos.map(
            (testContentInfoItem, index) => {
              return testContentInfoItem?.testMaterialInfos?.length > 0 ? (
                <CustomTabPanel key={index} value={showTab} index={index}>
                  <CreateTestContentInfoForm
                    testContentInfoItem={testContentInfoItem}
                    setTestContentInfoItem={(newValue) =>
                      handleChangeTestContentInfo(index, newValue)
                    }
                    requestFormInfo={requestFormInfo}
                    setRequestFormInfo={setRequestFormInfo}
                    customerTable={customerTable}
                    handleClickEditCus={handleClickEditCus}
                    onChangeCustomer={onChangeCustomer}
                  />
                </CustomTabPanel>
              ) : null;
            }
          )}
        </div>
      </div>

      <PageLoadingBackdrop open={isCreating} />
    </>
  );
}

function UpdateOrderContent() {
  const searchParams = new URLSearchParams(window.location.search);

  const [showSelectForm] = useState(!searchParams.get("id"));
  const [id, setId] = useState(searchParams.get("id"));
  const [caseId, setCaseId] = useState(searchParams.get("caseId"));
  const [selectedTestSchedule, setSelectedTestSchedule] = useState(null);
  const [selectedCaseInfo, setSelectedCaseInfo] = useState(null);

  const disableButtonSearch = useMemo(() => {
    return (
      !selectedTestSchedule ||
      !selectedTestSchedule?.id ||
      !selectedCaseInfo?._id ||
      selectedCaseInfo.caseStatus === caseStatus.completed ||
      selectedCaseInfo.caseStatus === caseStatus.lost
    );
  }, [selectedTestSchedule, selectedCaseInfo]);

  const reset = () => {
    setSelectedCaseInfo(null);
    setCaseId(null);
    setId(null);
  };

  const resetCaseId = (caseInfo) => {
    if (caseId !== caseInfo._id) {
      setCaseId(null);
      setId(null);
    }
  };

  const [loadInitState, setLoadInitState] = useState({
    isLoading: false,
    data: null,
    error: null,
  });

  const loadInit = (id) => {
    if (id) {
      setLoadInitState({
        isLoading: true,
        data: null,
        error: null,
      });

      orderServices
        .getByCaseId(caseId)
        .then((res) => {
          setLoadInitState((oldState) => ({
            ...oldState,
            isLoading: false,
            data: res.data,
            error: null,
          }));
        })
        .catch((error) => {
          toast.error(messages.callApiFail);
          setLoadInitState((oldState) => ({
            ...oldState,
            isLoading: false,
            data: null,
            error: error,
          }));
        });
    }
  };

  useEffect(() => {
    loadInit(id);
  }, [id]);

  const renderUpdateOrder = () => {
    const message = getMessageFromCaseStatus(selectedCaseInfo, true);
    if (message) {
      return (
        <div className="w-full h-auto">
          <p className="text-custom-size mb-3">{message}</p>
        </div>
      );
    }

    if (loadInitState.data && loadInitState.data?.id && loadInitState.data?.status !== 'draft' && id) {
      if (loadInitState.data.length === 0) {
        return <PageNoData />;
      }

      return (
        <UpdateOrderResult
          orderStatus={
            selectedCaseInfo?.requestFormStatus ||
            loadInitState.data?.requestFormStatus
          }
          initOrderInfo={loadInitState.data}
          caseId={caseId}
          handleSearch={() => loadInit(id)}
        />
      );
    }
  };

  return (
    <div className="w-full h-auto">
      {showSelectForm && (
        <>
          <div className="w-full h-auto mb-7 text-custom-size">
            <p>発注書（依頼書）の修正</p>
          </div>

          <div className="w-full h-auto flex items-end mb-12 flex-wrap justify-between">
            <div className="w-full mb-3 md:mb-0 md:w-auto flex-grow">
              <SelectTestScheduleAndCaseId
                schedule={selectedTestSchedule}
                setSchedule={(value) => {
                  reset();
                  setSelectedTestSchedule(value);
                }}
                caseInfo={selectedCaseInfo}
                setCaseInfo={(value) => {
                  resetCaseId(value);
                  setSelectedCaseInfo(value);
                }}
                labelWidth={160}
              />
            </div>
            <div className="w-full md:w-auto shrink-0 pl-12 flex justify-end">
              <Button
                onClick={() => {
                  setCaseId(selectedCaseInfo._id);
                  setId(
                    selectedCaseInfo.requestFormInfo?._id ||
                      selectedCaseInfo.draftRequestForm
                  );
                }}
                disabled={disableButtonSearch}
                type={disableButtonSearch ? "disabled" : "primary"}
              >
                検索する
              </Button>
            </div>
          </div>
        </>
      )}

      {id && loadInitState.isLoading ? <PageLoading /> : null}
      {id && !loadInitState.isLoading && loadInitState.error ? (
        <PageError />
      ) : null}
      {!loadInitState.isLoading && !loadInitState.error
        ? renderUpdateOrder()
        : null}
    </div>
  );
}

function UpdateOrder() {
  return (
    <ContentLayout
      sideMenuLinkOptions={[
        { linkTo: routePaths.order, linkTitle: "発注書の検索" },
        {
          linkTo: routePaths.orderUpdate(),
          linkTitle: "発注書の修正",
        },
        {
          linkTo: routePaths.orderCreate,
          linkTitle: "発注書の作成",
        },
        { linkTo: routePaths.topMenu, linkTitle: "トップへ戻る" },
      ]}
    >
      <UpdateOrderContent />
    </ContentLayout>
  );
}

export default UpdateOrder;
